import { render, staticRenderFns } from "./tabbifier-header.vue?vue&type=template&id=6f0d5cdc&scoped=true&"
import script from "./tabbifier-header.vue?vue&type=script&lang=js&"
export * from "./tabbifier-header.vue?vue&type=script&lang=js&"
import style0 from "./tabbifier-header.vue?vue&type=style&index=0&id=6f0d5cdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0d5cdc",
  null
  
)

export default component.exports